<template>
  <div id="app">
    <div v-if="!$route.meta.NoNeedHome" :class="classObj" class="app-wrapper">
      <div
        v-if="device === 'mobile' && sidebar.opened"
        class="drawer-bg"
        @click="handleClickOutside"
      />
      <div :class="{ 'has-logo': collapsed }" class="sidebar-container">
        <logo v-if="true" :collapse="collapsed" />
        <el-scrollbar wrap-class="scrollbar-wrapper">
          <el-menu
            :default-active="$route.path"
            @open="handleopen"
            @close="handleclose"
            @select="handleselect"
            unique-opened
            router
            :collapse="collapsed"
            :background-color="variables.menuBg"
            :text-color="variables.menuText"
            :active-text-color="variables.menuActiveText"
            mode="vertical"
          >
            <sidebar
              v-for="(menu, index) in routes"
              :key="index"
              :item="menu"
            />
          </el-menu>
        </el-scrollbar>
      </div>
      <div :class="{ hasTagsView: true }" class="main-container">
        <div :class="{ 'fixed-header': true }">
          <div class="navbar">
            <hamburger
              id="hamburger-container"
              :is-active="!collapsed"
              class="hamburger-container"
              @toggleClick="collapse"
            />
            <el-breadcrumb
              separator="/"
              id="breadcrumb-container"
              class="breadcrumb-container app-breadcrumb"
            >
              <el-breadcrumb-item
                v-for="item in $route.matched"
                :key="item.path"
              >
                <span style="no-redirect"> {{ item.name }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right-menu">
              <span
                style="color: red; margin-right: 20px; font-size: 14px"
                v-if="ExpirationDay <= 7"
                >软件有效期至：{{ ExpirationDate }}</span
              >
              <template v-if="device !== 'mobile'"> </template>
              <el-dropdown trigger="hover" slot="dropdown">
                <span
                  class="el-dropdown-link userinfo-inner"
                  style="cursor: pointer"
                >
                  <i class="el-icon-s-custom" style="font-size: 20px"></i>
                  {{ sysUserName }}
                  <i class="el-icon-caret-bottom" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="editpwdfrom.show = true"
                    ><i
                      class="fa fa-lock"
                      style="color: black; margin-right: 15px"
                      aria-hidden="true"
                    ></i
                    >修改密码</el-dropdown-item
                  >
                  <!-- <el-dropdown-item
                    v-if="platform === 'web'"
                    @click.native="downlodop()"
                    ><i
                      class="fa fa-cloud-download"
                      style="color: black"
                      aria-hidden="true"
                    ></i
                    >下载打印插件</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="platform === 'web'"
                    @click.native="downlodwin()"
                    ><i
                      class="fa fa-cloud-download"
                      style="color: black"
                      aria-hidden="true"
                    ></i
                    >下载Windows客户端</el-dropdown-item
                  > -->
                  <el-dropdown-item divided @click.native="logout"
                    ><i
                      class="fa fa-sign-out"
                      style="color: black"
                      aria-hidden="true"
                    ></i
                    >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div
            id="tags-view-container"
            class="tags-view-container"
            v-if="showTags"
          >
            <el-row
              ><el-col :span="23">
                <scroll-pane ref="scrollPane" class="tags-view-wrapper">
                  <router-link
                    v-for="(tag, index) in tagsList"
                    ref="tag"
                    :key="tag.path"
                    :class="{ active: isActive(tag.path) }"
                    :to="{
                      path: tag.path,
                      query: tag.query,
                      fullPath: tag.fullPath,
                    }"
                    tag="span"
                    @click.middle.native="closeTags(index)"
                    class="tags-view-item"
                  >
                    <span @click="refresh(tag.path)"> {{ tag.title }}</span>
                    <span
                      v-if="tagsList.length > 1"
                      class="el-icon-close"
                      @click.prevent.stop="closeTags(index)"
                    />
                  </router-link> </scroll-pane></el-col
              ><el-col :span="1">
                <div class="tags-close-box">
                  <el-dropdown @command="handleTags">
                    <el-button size="small" style="margin-top: 4px">
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu size="small" slot="dropdown">
                      <el-dropdown-item command="other"
                        >关闭其他</el-dropdown-item
                      >
                      <!-- <el-dropdown-item command="all">关闭所有</el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </el-col></el-row
            >
          </div>
        </div>
        <section class="app-main">
          <transition name="fade-transform" mode="out-in">
            <!-- 含有母版的路由页面 -->
            <router-view></router-view>
          </transition>
        </section>
      </div>
      <div
        class="v-modal"
        @click="collapse"
        v-show="SidebarVisible"
        tabindex="0"
        style="z-index: 2999"
      ></div>
      <el-dialog
        title="修改密码"
        :visible.sync="editpwdfrom.show"
        width="450px"
        :append-to-body="true"
        :modal-append-to-body="false"
        :destroy-on-close="true"
        :close-on-click-modal="false"
      >
        <el-form :model="editpwdfrom" ref="editpwdfrom" :rules="editpwdrules">
          <el-form-item label="原密码：" label-width="120px" prop="oldpwd">
            <el-input
              v-model="editpwdfrom.oldpwd"
              show-password
              show-word-limit
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码：" label-width="120px" prop="newpwd">
            <el-input
              v-model="editpwdfrom.newpwd"
              show-password
              maxlength="30"
              show-word-limit
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认新密码："
            label-width="120px"
            prop="renewpwd"
          >
            <el-input
              v-model="editpwdfrom.renewpwd"
              show-password
              maxlength="30"
              show-word-limit
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editpwdfrom.show = false">取 消</el-button>
          <el-button type="primary" @click="saveeditpwd()">确认修改</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-else>
      <transition name="fade" mode="out-in">
        <div class="content-az router-view-withly">
          <!-- 含有母版的路由页面 -->
          <router-view></router-view>
        </div>
      </transition>
    </div>
    <div
      class="tab_company_out"
      id="boxprint"
      style="width: 300px; display: none; line-height: 26px; font-size: 20px"
    >
      <div
        style="
          width: 300px;
          text-align: center;
          line-height: 30px;
          font-size: 20px;
        "
      >
        {{ printmodel.TypeName + "-" + printmodel.TableName + "（后厨)" }}
      </div>
      <table class="cont1" style="width: 300px; border-bottom: 1px solid #000">
        <tr>
          <td width="150">消费单号:</td>
          <td width="150" style="text-align: right">
            {{ printmodel.Id }}
          </td>
        </tr>
        <tr>
          <td width="150">点单时间:</td>
          <td width="150" style="text-align: right">
            {{ printmodel.printtime }}
          </td>
        </tr>
        <tr>
          <td width="150">顾客人数：</td>
          <td width="150" style="text-align: right">
            {{ printmodel.TablePeopleCount }}
          </td>
        </tr>
      </table>
      <div class="content">
        <table cellpadding="0" cellspacing="0" style="width: 300px">
          <!-- 每页显示onePageRow条数据 -->
          <div v-for="(row, index) in printmodel.printdetail" :key="index">
            <tr style="text-align: left; margin-top: 10px; font-size: 24px">
              <td colspan="2">{{ row.GoodsName }}</td>
            </tr>
            <tr style="text-align: left; margin-top: 10px; font-size: 20px">
              <td colspan="2">
                {{
                  row.Quantity +
                  row.UnitName +
                  " x " +
                  row.SellPrice +
                  "元 小计：" +
                  row.ShouldAmount +
                  "元"
                }}
              </td>
              <td colspan="2">`</td>
            </tr>
          </div>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from "./components/Sidebar";
import { editpwd } from "@/api/employee";
import Logo from "./components/Sidebar/Logo.vue";
import ScrollPane from "./components/ScrollPane";
import { getUserByToken } from "./api/auth";
import Hamburger from "@/components/Hamburger";
import applicationUserManager from "./Auth/applicationusermanager";
import userAuth from "./Auth/UserAuth";
import { mapState } from "vuex";
import variables from "@/style/variables.scss";
import { getttsurl } from "@/api/common";
import { getLodop } from "@/utils/LodopFuncs";
export default {
  components: { Sidebar, ScrollPane, Logo, Hamburger },
  mixins: [userAuth],
  data() {
    return {
      NewsVisible: false,
      collapsed: false,
      zModalShadow: false,
      SidebarVisible: false,
      collapsedClass: "menu-expanded",
      sysUserName: "",
      newsDialogCss: "news-dialog",
      sysUserAvatar: "",
      ExpirationDate: "",
      ExpirationDay: 999,
      printdevlist: [],
      tagsList: [],
      editpwdfrom: {
        show: false,
        oldpwd: "",
        newpwd: "",
        renewpwd: "",
      },
      editpwdrules: {
        oldpwd: [
          { required: true, message: "原密码不能为空", trigger: "blur" },
        ],
        newpwd: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
        ],
        renewpwd: [
          { required: true, message: "确认新密码不能为空", trigger: "blur" },
        ],
      },
      device: "",
      t: "",
      printmodel: {
        printtime: "",
        printdetail: [],
      },
      printdetaillist: [],
      routes: [],
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      onemark: false,
    };
  },
  destroyed() {
  },
  methods: {
    init() {
      if (
        window.localStorage.printdevlist != null &&
        window.localStorage.printdevlist != undefined
      ) {
        this.printdevlist = JSON.parse(window.localStorage.printdevlist);
      }
      try {
        let emp = JSON.parse(window.localStorage.getItem("user"));
        this.onemark = emp.syspara.filter(
          (it) => it.ParaKey === "ht19"
        )[0].ParaValue;
      } catch {}
    },
    async saveorderaddgoodsprint() {
      this.printmodel.printtime = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ");
      //打印商品
      for (let i = 1; i <= 5; i++) {
        try {
          let printdetail = this.printdetaillist.filter(
            (p) => p.PrintList.indexOf(i.toString()) > -1
          );
          if (printdetail.length > 0) {
            let printdev = this.printdevlist.filter(
              (p) => p.Id === i && p.Enable === true
            );
            if (this.onemark == true || this.onemark == "true") {
              if (printdev.length > 0) {
                let pr = printdev[0];
                this.printmodel.printdetail = printdetail;
                this.$forceUpdate();
                await this.printgoodsss(pr);
                let dylist = JSON.parse(JSON.stringify(printdetail));
                let length = dylist.length;
                for (let j = 0; j < length; j++) {
                  this.printmodel.printdetail = [dylist[j]];
                  this.$forceUpdate();
                  await this.printgoodsss(pr);
                }
              }
            } else {
              this.printmodel.printdetail = JSON.parse(
                JSON.stringify(printdetail)
              );
              if (printdev.length > 0) {
                await this.printgoodsss(printdev[0]);
              }
            }
          }
        } catch {}
      }
    },
    printgoodsss(printdev) {
      return new Promise((resolve) => {
        setTimeout(() => {
          let strHTML = document.getElementById("boxprint").innerHTML;
          try {
            printdev.printnum =
              printdev.printnum == undefined ? 1 : printdev.printnum;
            if (this.platform === "web") {
              let LODOP = getLodop();
              LODOP.PRINT_INIT("");
              LODOP.SET_PRINTER_INDEX(printdev.printname);
              if (printdev.paperwidth === "800") {
                LODOP.SET_PRINT_PAGESIZE(3, "80mm", "10mm", "CreateCustomPage");
              }
              if (printdev.paperwidth === "480") {
                LODOP.SET_PRINT_PAGESIZE(3, "48mm", "10mm", "CreateCustomPage");
              }
              LODOP.SET_PRINT_STYLE("FontSize", 15); // 设置打印字体
              LODOP.SET_PRINT_STYLE("Bold", 1); // 设置加粗
              LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Height:100%");
              LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Width");
              LODOP.ADD_PRINT_HTM(10, 0, "100%", "100%", strHTML);
              LODOP.SET_PRINT_COPIES(
                printdev.printnum == undefined ? 1 : printdev.printnum
              ); //指定份数
              //LODOP.PREVIEW();
              LODOP.PRINT();
            }
            if (this.platform === "win") {
              let basehtml = strHTML;
              for (let i = 1; i < printdev.printnum; i++) {
                strHTML +=
                  "<div style='page-break-before: always;'></div>" + basehtml;
              }
              if (printdev.paperwidth === "480") {
                strHTML += "<div style='text-aglin:left;height:30px'>.</div>";
                strHTML += "<div style='text-aglin:left'>.</div>";
                strHTML += "<div style='text-aglin:left'>.</div>";
              }
              window.ipcRender.send("do-print", {
                printerName: printdev.printname,
                html: strHTML,
                paperwidth: printdev.paperwidth,
              });
            }
          } catch {}
          resolve();
        }, 1500);
      });
    },
    gotappath(Path) {
      this.$router.replace({
        path: Path,
      });
    },
    toggleSideBar() {
      if (this.collapsed === false) {
        this.collapsed = true;
      } else {
        this.collapsed = false;
      }
    },
    downlodop() {
      window.open(
        "https://www.mtfpos.com/upfiles/CLodop_Setup_for_Win32NT.exe"
      );
    },
    downlodwin() {
      window.open("https://files.mtfpos.com/update/满天飞停车管理系统.exe");
    },
    saveeditpwd() {
      var _this = this;
      if (this.editpwdfrom.newpwd != this.editpwdfrom.renewpwd) {
        this.$message.error("新密码和确认新密码不一致，请重新输入");
      } else {
        editpwd({
          oldpwd: this.editpwdfrom.oldpwd,
          newpwd: this.editpwdfrom.newpwd,
        }).then((res) => {
          this.editpwdfrom.show = false;
          this.editpwdfrom.oldpwd = "";
          this.editpwdfrom.newpwd = "";
          this.editpwdfrom.renewpwd = "";
          this.$confirm("修改成功，点击确定重新登录！", "提示", {
            showClose: false,
            showCancelButton: false,
          })
            .then(() => {
              window.localStorage.removeItem("user");
              window.localStorage.removeItem("Token");
              window.localStorage.removeItem("TokenExpire");
              window.localStorage.removeItem("NavigationBar");
              window.localStorage.removeItem("refreshtime");
              window.localStorage.removeItem("router");
              sessionStorage.removeItem("Tags");
              global.antRouter = [];
              this.tagsList = [];
              this.routes = [];
              this.$store.commit("saveTagsData", "");
              if (global.IS_IDS4) {
                applicationUserManager.logout();
              } else {
                _this.$router.push("/");
                //window.location.reload()
              }
            })
            .catch(() => {});
        });
      }
    },
    refresh(path) {
      if (this.$route.path === path) {
        if (this.platform === "web") {
          window.location.reload();
        }
      }
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    toindex() {
      this.$router.replace({
        path: "/",
      });
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    onSubmit() {
      //console.log("submit!");
    },
    handleopen() {
      //console.log('handleopen');
    },
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function (a, b) {},
    //退出登录
    logout: function () {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          window.localStorage.removeItem("user");
          window.localStorage.removeItem("Token");
          window.localStorage.removeItem("TokenExpire");
          window.localStorage.removeItem("NavigationBar");
          window.localStorage.removeItem("refreshtime");
          window.localStorage.removeItem("router");
          sessionStorage.removeItem("Tags");
          global.antRouter = [];
          this.tagsList = [];
          this.routes = [];
          this.$store.commit("saveTagsData", "");
          if (global.IS_IDS4) {
            applicationUserManager.logout();
          } else {
            _this.$router.push("/");
            //window.location.reload()
          }
        })
        .catch(() => {});
    },
    //折叠导航栏
    collapse: function () {
      this.collapsed = !this.collapsed;
      if (this.collapsed) {
        this.collapsedClass = "menu-collapsed";
        this.SidebarVisible = false;
      } else {
        this.collapsedClass = "menu-expanded";
        if (window.screen.width < 680) {
          this.SidebarVisible = true;
        }
      }
      //记录折叠状态
      window.localStorage.collapse = this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
    isActive(path) {
      return path === this.$route.fullPath;
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList.splice(index, 1)[0];
      const item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
        this.$store.commit("saveTagsData", JSON.stringify(this.tagsList));
      } else {
        this.$router.push("/");
      }
    },
    // 关闭全部标签
    closeAll() {
      this.tagsList = [];
      this.$router.push("/");
      sessionStorage.removeItem("Tags");
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter((item) => {
        return item.path === this.$route.fullPath;
      });
      this.tagsList = curItem;
      sessionStorage.setItem("Tags", JSON.stringify(this.tagsList));
    },
    // 设置标签
    setTags(route) {
      let vm = this;
      if (!route.meta.NoTabPage) {
        const isExist = vm.tagsList.some((item) => {
          return item.path === route.fullPath;
        });
        if (
          !isExist &&
          route.meta.title != undefined &&
          route.meta.title.length > 1
        ) {
          vm.tagsList.push({
            title: route.meta.title,
            path: route.fullPath,
            // name: route.matched[1].components.default.name
          });
        }
      }
    },
    // 当关闭所有页面时隐藏
    handleTags(command) {
      command === "other" ? this.closeOther() : this.closeAll();
    },
    getUserInfoByToken(token) {
      var _this = this;
      var loginParams = { token: token };
      getUserByToken(loginParams).then((data) => {
        this.logining = false;
        if (!data.success) {
          _this.$message({
            message: data.message,
            type: "error",
          });
        } else {
          _this.$notify({
            type: "success",
            message: `欢迎管理员：${data.response.EmpName} ！`,
            duration: 3000,
          });
          _this.sysUserName = data.response.EmpName;
          window.localStorage.user = JSON.stringify(data.response);
        }
      });
    },
  },
  mounted() {
    let vm = this;
    vm.ExpirationDate = window.localStorage.ExpirationDate;
    vm.ExpirationDay = window.localStorage.ExpirationDay;
    var tags = sessionStorage.getItem("Tags")
      ? JSON.parse(sessionStorage.getItem("Tags"))
      : [];
    if (tags && tags.length > 0) {
      vm.tagsList = tags;
    }
    var NavigationBar = JSON.parse(
      window.localStorage.router ? window.localStorage.router : null
    );
    // var NavigationBar = global.antRouter;
    if (vm.routes.length <= 0 && NavigationBar && NavigationBar.length >= 0) {
      vm.routes = NavigationBar;
    }
    // 折叠菜单栏
  },
  updated() {
    var user = JSON.parse(
      window.localStorage.user ? window.localStorage.user : null
    );
    if (user) {
      this.sysUserName = user.EmpName;
      this.sysUserAvatar = user.avatar;
    }
    var NavigationBar = JSON.parse(
      window.localStorage.router ? window.localStorage.router : null
    );
    if (NavigationBar && NavigationBar.length >= 0) {
      if (
        this.routes.length <= 0 ||
        JSON.stringify(this.routes) != JSON.stringify(NavigationBar)
      ) {
        this.routes = NavigationBar;
      }
    }
  },
  computed: {
    ...mapState({
      //sidebar: state => state.app.sidebar,
      //device: state => state.app.device,
      // showSettings: state => state.settings.showSettings,
      // needTagsView: state => state.settings.tagsView,
      // fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: this.collapsed,
        openSidebar: !this.collapsed,
        withoutAnimation: false,
        mobile: this.device === "mobile",
      };
    },
    showTags() {
      if (this.tagsList.length > 1) {
        this.$store.commit("saveTagsData", JSON.stringify(this.tagsList));
      }
      return this.tagsList.length > 0;
    },
    variables() {
      return variables;
    },
  },
  watch: {
    // 对router进行监听，每当访问router时，对tags的进行修改
    $route: async function (newValue, from) {
      if (global.IS_IDS4) {
        await this.refreshUserInfo();
      }
      this.setTags(newValue);
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        if (tags) {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              this.$refs.scrollPane.moveToTarget(tag, tags);
              // when query is different then update
              // if (tag.to.fullPath !== this.$route.fullPath) {
              //     this.$store.dispatch('tagsView/updateVisitedView', this.$route)
              // }
              break;
            }
          }
        }
      });
    },
  },
  created() {
    this.init();
    // 第一次进入页面时，修改tag的值
    this.setTags(this.$route);
    //读取折叠状态
    if (window.localStorage.collapse == "true") {
      this.collapsed = false;
      this.collapse();
    } else {
      this.collapsed = true;
      this.collapse();
    }
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/mixin.scss";
@import "~@/style/variables.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}
.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}
.mobile .fixed-header {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0px 1px 4px rgba(0, 21, 41, 0.08);
  // border-top: 1px solid rgba(0, 21, 41, 0.08);
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;
      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}
.tags-close-box {
  box-sizing: border-box;
  text-align: center;
  z-index: 10;
  float: right;
  margin-right: 1px;
  line-height: 2;
}
.fixed-header + .app-main {
  padding-top: 50px;
}
.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }
  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>
<style lang="scss" scoped>
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 0px;
  }
}
</style>
<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
<style lang="scss" scoped>
.tags-view-container {
  height: 40px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 32px;
      line-height: 32px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 14px;
      margin-left: 5px;
      margin-top: 4px;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #42b983;
        color: #fff;
        border-color: #42b983;
        &::before {
          content: "";
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>
<style lang="scss" >
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 22px;
      height: 22px;
      vertical-align: 3px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;
      margin-left: 3px;
      &:before {
        transform: scale(0.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>
<style lang="css">
@import "~@/style/content.css";
.app-main .scrollbar-handle .el-scrollbar__wrap {
  margin-bottom: 0px !important;
  margin-right: 0px !important;
}
.el-col .el-scrollbar .el-scrollbar__wrap {
  margin-right: 0px !important;
}
.fa {
  vertical-align: baseline;
  margin-right: 10px;
}
.dialogshow {
  width: 95%;
  margin-left: 2.5%;
}
.dialogshow-detail {
  margin-bottom: 0;
  padding: 10px 20px;
}
.dialoForm-footer {
  width: 98%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  z-index: 5;
  background: #fff;
}
.el-drawer__header {
  margin-bottom: 5px !important;
  padding: 5px 20px !important;
  height: 50px;
  line-height: 50px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  /* border-top: 1px solid rgba(0, 21, 41, 0.08); */
}
.el-menu-vertical-demo {
  /*width: 230px;*/
}
</style>
